"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PartnerRenderListOfCards = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireDefault(require("react"));
var _index = require("./index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const PartnerRenderListOfCards = partners => {
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "con-partner-wrapper"
  }, partners.map(item => {
    return /*#__PURE__*/_react.default.createElement(_index.PartnerCard, {
      key: item.partnerId,
      imageUrl: item.imageUrl,
      name: item.name,
      description: item.description,
      learnMore: item.learnMore
    });
  }));
};
exports.PartnerRenderListOfCards = PartnerRenderListOfCards;